









































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { EventBus } from "@/pitprojekt/event-bus";
import { NavigationItem } from "@/pitprojekt/types";
import _ from 'lodash'

@Component({})
export default class NavigationDrawer extends Vue {
    drawer: boolean = true;
    navigationItems: Array<NavigationItem> = [
        {
            'title': 'Dashboard',
            'icon': 'dashboard',
            'route': 'dashboard',
            'active': false,
            'children': []
        },
        {
            'title': 'Uruchomienia',
            'icon': 'touch_app',
            'active': false,
            'children': [
                {
                    'title': 'Analiza statystyk',
                    'route': 'stats-uruchomienia-index',
                    'alternativeRoutes': ['stats-uruchomienia-product'],
                    'active': false,
                },
                {
                    'title': 'Przeglądanie',
                    'route': 'stats-uruchomienia-details-index',
                    'active': false,
                }
            ]
        },
        {
            'title': 'Pobrania',
            'icon': 'cloud_download',
            'active': false,
            'children': [
                {
                    'title': 'Analiza statystyk',
                    'route': 'stats-pobrania-index',
                    'alternativeRoutes': ['stats-pobrania-product'],
                    'active': false,
                },
                {
                    'title': 'Przeglądanie',
                    'route': 'stats-pobrania-details-index',
                    'active': false,
                }
            ]
        },
         {
            'title': 'Deklaracje',
            'icon': 'insert_drive_file',
            'active': false,
            'children': [
                {
                    'title': 'Analiza statystyk',
                    'route': 'stats-deklaracje-index',
                    'alternativeRoutes': ['stats-deklaracje-product'],
                    'active': false,
                },
                {
                    'title': 'Przeglądanie',
                    'route': 'stats-deklaracje-details-index',
                    'active': false,
                }
            ]
        }

    ];

    navigateTo(route: string) {
        if (route !== undefined && route !== this.$route.name) {
            this.$router.push({ name: route})
        }
    }

    toggleDrawer():void {
        this.drawer = !this.drawer;
    }

    created() {
        this.setActivePropByRoute();
        EventBus.$on('toggleNavigationDrawer', this.toggleDrawer);
    }

    setActivePropByRoute() {
        this.resetAllActivePropInSubItems();

        this.navigationItems.forEach(item => {
            if (item.route === this.$route.name) {
                _.delay(function () {
                    item.active = true;
                }, 300)
                return false
            }
            item.children.forEach(subItem => {
                if (subItem.route === this.$route.name || (subItem.alternativeRoutes != undefined && subItem.alternativeRoutes.includes(this.$route.name) )) {
                _.delay(function () {
                    item.active = true;
                    subItem.active = true;
                }, 300)
                return false
                }
            })
        })
    }

    resetAllActivePropInSubItems() {
        this.navigationItems.forEach(item => {
            item.children.forEach(subItem => {
                subItem.active = false;
            })
        })
    }

    @Watch('$route', { immediate: true, deep: true })
    updateRoute() {
        this.setActivePropByRoute();
    }

}
